import makeSlice from '@web/slices/pointPayment/sliceMaker'

const pointPaymentSlice = makeSlice({})

export default pointPaymentSlice.reducer
